import React, { useContext, MouseEvent } from "react";

//MUI
import Button from "@mui/material/Button";

//Custom Components
import UserContext from "@/components/UserContext/UserContext";

//Types
import { ITableButtonProps, AllowType } from "@/@types/ui/Table";

const TableButton: React.FC<ITableButtonProps> = (props) => {
  const userContext = useContext(UserContext);
  const { disabled,allow = "always", selection, onClick, needPermission, isEnabledRecord, iconCondition, TrueIcon, FalseIcon, startIcon, ...otherProps } = props;

  const isEnabled = function (allow: AllowType, selection: Array<string>): boolean {
    switch (allow) {
      case "always":
        return true;
      case "one":
        return selection.length === 1;
      case "many":
        return selection.length > 0;
      default:
        return false;
    }
  };

  const handleClick = function (evt: MouseEvent<HTMLButtonElement>) {
    onClick(evt, selection);
  };

  const isDisabled = !isEnabled(allow, selection) || (isEnabledRecord ? !isEnabledRecord(selection) : false) || disabled;

  const iconUsed = iconCondition && TrueIcon && FalseIcon ? (iconCondition(selection) ? <TrueIcon/> : <FalseIcon/>) : startIcon;

  return needPermission && userContext !== null && !userContext.hasAnyPermission(needPermission) ? null : (
    <Button
      color="primary"
      size="small"
      {...otherProps}
      startIcon={iconUsed}
      disabled={isDisabled}
      onClick={handleClick}
      sx={{
        ml: 1,
        mr: 0
      }}
    >
      {props.children}
    </Button>
  );
};

export default TableButton;
